import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Tooltip } from '@material-ui/core'
import BrandedDocument from '../../../../molecules/BrandedDocument'
import DenaliLogo from '../../../../../apps/aiApp/Assistant/common/DenaliLogo'
import Icon from '../../../../atoms/Icon'
const tableDefault = '/img/catalog_database_pb.svg'

function DatasourceLink ({ datasource }) {
  const badges = useMemo(() => {
    const result = []
    if (datasource.isAiEnabled) {
      result.push((
        <div key='denali_logo_ai_enabled' className='p-xs'>
          <Tooltip title='AI-Enabled'>
            <div className='px-1 m-sm bg-neutral-050 radius-sm' style={{ border: 'var(--border-neutral-thin)' }}>
              <DenaliLogo size='24px' />
            </div>
          </Tooltip>
        </div>
      ))
    }
    if (datasource.isDeprecated) {
      result.push((
        <div key='denali_logo_deprecated' className='p-xs'>
          <Tooltip title='Deprecated'>
            <div className='px-1 m-sm bg-neutral-050 radius-sm' style={{ border: 'var(--border-neutral-thin)' }}>
              <Icon customSize='24px' name='delete' style={{ fill: 'var(--color-warning-500)' }} />
            </div>
          </Tooltip>
        </div>
      ))
    }

    return result
  }, [datasource])

  return (
    <Link to={`/admin/denali/catalog/s/${datasource.catalogDatasourceId}`} key={datasource.code}>
      <BrandedDocument
        name={datasource.displayName}
        imageUrl={datasource.imageUrl || tableDefault}
        badges={badges}
      />
    </Link>
  )
}

DatasourceLink.propTypes = {
  datasource: PropTypes.shape({
    catalogDatasourceId: PropTypes.number,
    code: PropTypes.string,
    displayName: PropTypes.string,
    imageUrl: PropTypes.string,
    isAiEnabled: PropTypes.bool,
    isDeprecated: PropTypes.bool,
    namespace: PropTypes.shape({
      displayName: PropTypes.string
    })
  })
}

export default DatasourceLink
